var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29318 4.96556C8.95999 3.028 10.2934 2.05923 11.8162 2.00336C11.9384 1.99888 12.0607 1.99888 12.1828 2.00336C13.7056 2.05923 15.039 3.028 17.7059 4.96556C20.3727 6.90311 21.7061 7.87189 22.2298 9.30291C22.2718 9.41771 22.3096 9.534 22.3431 9.65157C22.7605 11.1171 22.2512 12.6846 21.2326 15.8197L19.5115 21.1164C19.2381 21.958 18.4538 22.5279 17.5689 22.5279C16.4408 22.5279 15.5262 21.6133 15.5262 20.4852V17.7363C15.5262 16.6778 14.6681 15.8197 13.6096 15.8197H10.3894C9.33091 15.8197 8.47281 16.6778 8.47281 17.7363V20.4852C8.47281 21.6133 7.55828 22.5279 6.43016 22.5279C5.54524 22.5279 4.76095 21.958 4.48749 21.1164L2.76647 15.8197C1.74783 12.6846 1.23852 11.1171 1.65596 9.65157C1.68945 9.534 1.72724 9.41771 1.76925 9.30291C2.29295 7.87189 3.62636 6.90311 6.29318 4.96556Z",
    fill: "#001F06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4dc39a9c7eb135fe4c5015d7767ae87e.svg";
export { ForwardRef as ReactComponent };